import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import About from '@/components/About'
import Markets from '@/components/Markets'
import Products from '@/components/Products'
import ProductsMain from '@/components/ProductsMain'
import Sustainability from '@/components/Sustainability'
import Careers from '@/components/Careers'
import Investors from '@/components/Investors'
import News from '@/components/News'
import NewsPreview from '@/components/news/NewsPreview'
import Contacts from '@/components/Contacts'
import DownloadCenter from '@/components/DownloadCenter'
import Sitemap from '@/components/Sitemap'
import DisclosurePolicy from '@/components/DisclosurePolicy'
import Terms from '@/components/Terms'
import PersonalData from '@/components/PersonalData'
import Administration from '@/components/administration/Administration'
import AdministrationLogin from '@/components/administration/AdministrationLogin'
import NotFound from '@/components/NotFound'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about-the-company/:page',
      name: 'AboutPage',
      component: About
    },
    {
      path: '/about-the-company',
      name: 'About',
      component: About
    },
    {
      path: '/markets/:page',
      name: 'MarketsPage',
      component: Markets
    },
    {
      path: '/products/:category/:product',
      name: 'Products',
      component: Products
    },
    {
      path: '/products',
      name: 'ProductsMain',
      component: ProductsMain
    },
    {
      path: '/sustainability/:page',
      name: 'Sustainability',
      component: Sustainability
    },
    {
      path: '/careers/:page',
      name: 'Careers',
      component: Careers
    },
    {
      path: '/investors/:page',
      name: 'Investors',
      component: Investors
    },
    {
      path: '/news/:url',
      name: 'NewsPreview',
      component: NewsPreview
    },
    {
      path: '/news',
      name: 'News',
      component: News
    },
    {
      path: '/contacts/:page/:profile',
      name: 'ContactsProfile',
      component: Contacts
    },
    {
      path: '/contacts/:page',
      name: 'Contacts',
      component: Contacts
    },
    {
      path: '/download-center/:page',
      name: 'DownloadCenter',
      component: DownloadCenter
    },
    {
      path: '/sitemap',
      name: 'Sitemap',
      component: Sitemap
    },
    {
      path: '/disclosure-policy',
      name: 'DisclosurePolicy',
      component: DisclosurePolicy
    },
    {
      path: '/terms-of-use',
      name: 'Terms',
      component: Terms
    },
    {
      path: '/personal-data',
      name: 'PersonalData',
      component: PersonalData
    },
    {
      path: '/admin',
      name: 'Administration',
      component: Administration,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/login',
      name: 'AdministrationLogin',
      component: AdministrationLogin,
    },
    {
      path: '/404',
      name: 'Not Found',
      component: NotFound
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = localStorage.getItem("token");
    if (!token) {
      next({
        path: '/admin/login'
      });
    } else {
      next();
    }
  } else {
    next();
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js